import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Check, X, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import axios from 'axios';

const PaymentTest = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentResult, setPaymentResult] = useState(null);

  const testPayment = async () => {
    setIsProcessing(true);
    setPaymentResult(null);

    try {
      // Test payment creation
      const createResponse = await axios.post('/api/payment/create', {
        plan_id: 1, // Basic plan
        billing_cycle: 'monthly',
        payment_method: 'credit_card'
      });

      console.log('Payment created:', createResponse.data);

      // Simulate payment verification after 2 seconds
      setTimeout(async () => {
        try {
          const verifyResponse = await axios.post('/api/payment/verify', {
            transaction_id: createResponse.data.transaction_id,
            status: 'success'
          });

          console.log('Payment verified:', verifyResponse.data);
          setPaymentResult('success');
          toast.success('Test ödeme başarılı!');
        } catch (error) {
          console.error('Verification error:', error);
          setPaymentResult('error');
          toast.error('Ödeme doğrulama hatası');
        } finally {
          setIsProcessing(false);
        }
      }, 2000);

    } catch (error) {
      console.error('Payment creation error:', error);
      setPaymentResult('error');
      toast.error('Ödeme oluşturma hatası');
      setIsProcessing(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gray-800 rounded-2xl p-8 max-w-md w-full"
      >
        <div className="text-center mb-8">
          <CreditCard className="w-16 h-16 text-blue-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-white mb-2">Ödeme Sistemi Testi</h1>
          <p className="text-gray-400">
            Premium abonelik ödeme sistemini test edin
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <div className="bg-gray-700 rounded-lg p-4">
            <h3 className="text-white font-semibold mb-2">Test Detayları</h3>
            <div className="text-sm text-gray-400 space-y-1">
              <div>Plan: Basic (Aylık)</div>
              <div>Fiyat: ₺100</div>
              <div>Yöntem: Kredi Kartı</div>
              <div>Durum: Simulated</div>
            </div>
          </div>
        </div>

        <button
          onClick={testPayment}
          disabled={isProcessing}
          className="w-full bg-blue-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center"
        >
          {isProcessing ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin mr-2" />
              Test Ediliyor...
            </>
          ) : (
            'Test Ödeme Başlat'
          )}
        </button>

        {paymentResult && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className={`mt-6 p-4 rounded-lg flex items-center space-x-3 ${
              paymentResult === 'success'
                ? 'bg-green-500/10 border border-green-500/20'
                : 'bg-red-500/10 border border-red-500/20'
            }`}
          >
            {paymentResult === 'success' ? (
              <Check className="w-5 h-5 text-green-400" />
            ) : (
              <X className="w-5 h-5 text-red-400" />
            )}
            <span
              className={
                paymentResult === 'success' ? 'text-green-400' : 'text-red-400'
              }
            >
              {paymentResult === 'success'
                ? 'Test ödeme başarılı!'
                : 'Test ödeme başarısız!'}
            </span>
          </motion.div>
        )}

        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            Bu test gerçek ödeme yapmaz, sadece sistem entegrasyonunu test eder.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentTest;
